import {useSelector} from 'react-redux'
import {AppRootState} from '../model/config'

const useFavoriteApps = () => {
  const favoriteApps = useSelector(
    (state: AppRootState) => state.app.favoriteApps
  )

  return [favoriteApps]
}

export default useFavoriteApps
